import { createAction, props } from '@ngrx/store';
import { KontaktKategorie, KontaktResource, VerfahrenKontakt } from '@schir-int-client/adressverwaltung-shared';
import {
	NewVerfahren,
	RegisterAusdruckType,
	VerfahrenListResource,
	VerfahrenResource,
	VerfahrenSearchQuery,
	ZaehlblattAktionen,
	ZaehlblattEntryListResource,
	ZaehlblattEntryResource,
} from './verfahren.model';

const PREFIX = '[Verfahren] ';

export const askToDeleteVerfahrenAction = createAction(
	PREFIX + 'Ask To Delete Verfahren',
	props<{
		verfahren: VerfahrenResource;
	}>()
);

export const deleteVerfahrenAction = createAction(
	PREFIX + 'Delete Verfahren',
	props<{
		verfahren: VerfahrenResource;
	}>()
);

export const loadVerfahrenAction = createAction(PREFIX + 'Load Verfahren');

export const loadVerfahrenSuccessAction = createAction(
	PREFIX + 'Load Verfahren Success',
	props<{
		verfahrenList: VerfahrenListResource;
	}>()
);

export const loadVerfahrenSingleAction = createAction(
	PREFIX + 'Load Verfahren Single',
	props<{
		verfahrenUri: string;
	}>()
);

export const loadVerfahrenSingleSuccessAction = createAction(
	PREFIX + 'Load Verfahren Single Success',
	props<{
		verfahren: VerfahrenResource;
		predecessor?: VerfahrenResource;
	}>()
);

export const updateVerfahrenSuccessAction = createAction(
	PREFIX + 'Update Verfahren Success',
	props<{
		verfahren: VerfahrenResource;
	}>()
);

export const searchForVerfahrenAction = createAction(
	PREFIX + 'Search For Verfahren',
	props<{
		query: VerfahrenSearchQuery;
		keepVerfahrenSingle: boolean;
	}>()
);

export const getLastOpenedVerfahrenAction = createAction(
	PREFIX + 'get last opened Verfahren',
	(props: { keepVerfahrenSingle: boolean }) => ({
		...props,
		query: {
			searchString: '',
			searchIn: [],
			filterByStatus: [],
		},
	})
);

export const searchForVerfahrenSuccessAction = createAction(
	PREFIX + 'Search For Verfahren Success',
	props<{
		verfahrenList: VerfahrenListResource;
		query: VerfahrenSearchQuery;
		keepVerfahrenSingle: boolean;
	}>()
);

export const downloadAmtlicherAuszugAction = createAction(PREFIX + 'Download Amtlicher Auszug');

export const downloadAusdruckAction = createAction(
	PREFIX + 'Download Ausdruck',
	props<{
		ausdruckType: RegisterAusdruckType;
	}>()
);

export const downloadAusdruckSuccessAction = createAction(
	PREFIX + 'Download Ausdruck Success',
	props<{
		data: Blob;
	}>()
);

export const downloadSchiffszertifikatAction = createAction(PREFIX + 'Download Schiffszertifikat');

export const downloadSchiffsbriefAction = createAction(PREFIX + 'Download Schiffsbrief');

export const downloadAmtlicherAuszugSuccessAction = createAction(
	PREFIX + 'Download Amtlicher Auszug Success',
	props<{
		data: Blob;
	}>()
);

export const downloadSchiffszertifikatSuccessAction = createAction(
	PREFIX + 'Download Schiffszertifikat Success',
	props<{
		data: Blob;
	}>()
);

export const downloadSchiffsbriefSuccessAction = createAction(
	PREFIX + 'Download Schiffsbrief Success',
	props<{
		data: Blob;
	}>()
);

export const createVerfahrenSuccessAction = createAction(PREFIX + 'Create Verfahren Success');

export const createVerfahrenFailAction = createAction(
	PREFIX + 'Create Verfahren Fail',
	props<{
		error: any;
	}>()
);

export const updateVerfahrenNotizAction = createAction(
	PREFIX + 'Update Verfahren Notiz',
	props<{
		notiz: string;
		verfahrenUri: string;
	}>()
);

export const assignUSignalAction = createAction(
	PREFIX + 'Assign U-Signal',
	props<{
		verfahren: VerfahrenResource;
	}>()
);

export const reportNoUSignalLeftAction = createAction(
	PREFIX + 'Report No U-Signal Left',
	props<{
		payload: any;
	}>()
);

export const reportDuplicateUSignalAction = createAction(
	PREFIX + 'Report Duplicate U-Signal',
	props<{
		payload: any;
	}>()
);

export const reloadSearchResultAction = createAction(PREFIX + 'Reload Search Result');

export const createVerfahrenAction = createAction(
	PREFIX + 'Create Verfahren',
	props<{
		newVerfahren: NewVerfahren;
	}>()
);

export const verfahrenBearbeitenAction = createAction(PREFIX + 'Verfahren Bearbeiten');

export const verfahrenBearbeitenBeendenAction = createAction(PREFIX + 'Verfahren Bearbeiten Beenden');

export const verfahrenUebernehmenAction = createAction(PREFIX + 'Verfahren Uebernehmen');

export const markVerfahrenAsAbgelehntAction = createAction(
	PREFIX + 'Mark Verfahren As Abgelehnt',
	props<{
		verfahren: VerfahrenResource;
	}>()
);

export const askToMarkVerfahrenAsAbgelehntAction = createAction(
	PREFIX + 'Ask To Mark Verfahren As Abgelehnt',
	props<{
		verfahren: VerfahrenResource;
	}>()
);

export const askToUnassignKontaktAction = createAction(
	PREFIX + 'Ask To Unassign Kontakt',
	props<{
		verfahrenKontakt: VerfahrenKontakt;
	}>()
);

export const unassignKontaktAction = createAction(
	PREFIX + 'Unassign Kontakt',
	props<{
		kontakt: KontaktResource;
		kategorie: KontaktKategorie;
	}>()
);

export const unassignKontaktSuccessAction = createAction(
	PREFIX + 'Unassign Kontakt Success',
	props<{
		verfahren: VerfahrenResource;
		kategorie: KontaktKategorie;
	}>()
);

// corresponding success action is VerfahrenUpdatedSuccessAction
export const setVerfahrenPropertyAction = createAction(
	PREFIX + 'Set Verfahren Property',
	props<{
		verfahren: VerfahrenResource;
		linkRel: string;
		value: string;
	}>()
);

export const setZugeordneteVerfahrenAction = createAction(
	PREFIX + 'Set Zugeordnete Verfahren',
	props<{
		verfahren: VerfahrenResource;
		zugeordneteVerfahren: number[];
	}>()
);

export const loadZaehlblattAction = createAction(
	PREFIX + 'Load Zaehlblatt',
	props<{
		verfahren: VerfahrenResource;
	}>()
);

export const loadZaehlblattSuccessAction = createAction(
	PREFIX + 'Load Zaehlblatt Success',
	props<{
		zaehlblatt: ZaehlblattEntryListResource;
	}>()
);

export const addZaehlblattAktionenAction = createAction(
	PREFIX + 'Add Zaehlblatt Aktionen',
	props<{
		values: ZaehlblattAktionen;
		zaehlblatt: ZaehlblattEntryListResource;
	}>()
);

export const deleteZaehlblattAktionAction = createAction(
	PREFIX + 'Delete Zaehlblatt Aktion',
	props<{
		entry: ZaehlblattEntryResource;
	}>()
);

export const exportVerfahrenAction = createAction(
	PREFIX + 'Export Verfahren',
	props<{
		url: string;
	}>()
);

export const exportVerfahrenSuccessAction = createAction(
	PREFIX + 'Export Verfahren Success',
	props<{
		data: Blob;
	}>()
);
